﻿export class ImageProcessingOptions {
    constructor(public convertFormat: boolean, public scale: number, public cropWidth: number, public cropHeight: number) { }
}